import { createReducer } from "redux-starter-kit";
import {
  startLoadNotiAction,
  endLoadNotiAction,
  notiFailLoadAction,
  notiDelAction
} from "../actions/notification";

const INIT_STATE = {
  loaded: false,
  notifications: [],
  errMsg: null
};

const notification = createReducer(INIT_STATE, {
  [startLoadNotiAction]: (state, action) => {
    state.loaded = false;
    state.errMsg = null;
  },
  [endLoadNotiAction]: (state, action) => {
    state.loaded = true;
    state.notifications = action.payload.notifications.reverse();
    state.errMsg = null;
  },
  [notiFailLoadAction]: (state, action) => {
    state.loaded = true;
    state.notifications = [];
    state.errMsg = action.payload.errMsg;
  },
  [notiDelAction]: (state, action) => {
    state.notifications = state.notifications.filter(notification => {
      return notification.id !== action.payload.notificationID;
    });
  }
});

export default notification;
